import { useCallback, useEffect, useRef, useState } from 'react';
import YoungApprenticeService from '../services/YoungApprenticeService';

/** Keep aggregate counts current while the dashboard is open. */
export default function useYoungApprenticeDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const refreshRef = useRef(() => {});
  const load = useCallback(() => refreshRef.current(), []);

  useEffect(() => {
    let disposed = false;
    let inFlight = false;
    const refresh = async () => {
      if (disposed || inFlight || document.visibilityState === 'hidden') return;
      inFlight = true;
      try {
        const next = await YoungApprenticeService.dashboard();
        if (!disposed) { setData(next); setError(''); }
      } catch (err) {
        if (!disposed) setError(err?.response?.data?.error || 'Não foi possível atualizar o Dashboard.');
      } finally {
        inFlight = false;
        if (!disposed) setLoading(false);
      }
    };
    refreshRef.current = refresh;
    refresh();
    const timer = window.setInterval(refresh, 2000);
    window.addEventListener('focus', refresh);
    window.addEventListener('ibpm:student-list-refreshed', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      disposed = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('ibpm:student-list-refreshed', refresh);
      document.removeEventListener('visibilitychange', refresh);
      refreshRef.current = () => {};
    };
  }, []);

  return { data, loading, error, load };
}
